import { render } from "./QuadstarPlanSelector.vue?vue&type=template&id=2fe3666e&scoped=true"
import script from "./QuadstarPlanSelector.vue?vue&type=script&lang=js"
export * from "./QuadstarPlanSelector.vue?vue&type=script&lang=js"

import "./QuadstarPlanSelector.vue?vue&type=style&index=0&id=2fe3666e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe3666e"]])

export default __exports__